import parsePhoneNumber, { AsYouType, isValidPhoneNumber, PhoneNumber } from 'libphonenumber-js';

export function isNumberValidPhoneNumber(phoneNumber?: string): boolean {
  return !Boolean(phoneNumber) ? false : isValidPhoneNumber(phoneNumber!, 'US');
}

export function convertToPhoneNumber(phoneNumber: string): PhoneNumber | undefined {
  return parsePhoneNumber(phoneNumber, 'US');
}

export function formatToNationalNumber(phoneNumber: string): string | undefined {
  return parsePhoneNumber(phoneNumber, 'US')?.formatNational();
}

export function formatToNumber(phoneNumber: string): string | undefined {
  return parsePhoneNumber(phoneNumber, 'US')?.number;
}

export function getAsYouType(): AsYouType {
  return new AsYouType('US');
}
